export default "/assets/images/hero_mila2.587c138d6d8b8331.webp";